// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qqNK","label":"styles_label__2wYWE"};